import type { DatadogRum as RumPublicApi } from '@datadog/browser-rum';
import { formatDatadogServiceName } from '../../utils/formatDatadogServiceName';
import {
  logToBrowser,
  logToJWeb,
  shouldClearInterval
} from '../../utils/sessionLogger';
import { ManifestType } from '@clientos/types';

class DatadogRum {
  init(manifest: ManifestType) {
    const {
      enable,
      sessionSampleRate,
      applicationId,
      service,
      clientToken,
      sessionReplaySampleRate
    } = manifest?.services?.monitoring?.providers?.datadog || {};
    const { appName: portalName, stack: environment } = manifest?.portal || {};

    try {
      if (enable && clientToken && applicationId) {
        const datadogRum: RumPublicApi = this.getDatadogRum();
        datadogRum.init({
          applicationId,
          clientToken,
          site: 'datadoghq.com',
          service: formatDatadogServiceName(service || portalName),
          env: environment,
          sessionSampleRate: this.getValidSampleRate(sessionSampleRate, 50),
          sessionReplaySampleRate: this.getValidSampleRate(
            sessionReplaySampleRate,
            50
          )
        });
        this.logDatadogSessionIdWhenAvailable();
      }
    } catch (error) {
      console.error(error);
    }
  }

  private getValidSampleRate(rate: number, defaultRate: number): number {
    return typeof rate === 'number' && rate >= 0 && rate <= 100
      ? rate
      : defaultRate;
  }

  private logDatadogSessionIdWhenAvailable() {
    let loggedToBrowser = false;
    let loggedToJWeb = false;
    const startTime = new Date().getTime();
    const timeout = 10 * 1000;
    const intervalCheckToLogDatadogId = setInterval(() => {
      try {
        const datadogRum = this.getDatadogRum();
        const datadogRumSessionId =
          datadogRum?.getInternalContext?.()?.session_id;
        const jWeb = (window as any)?.JWeb;

        if (datadogRumSessionId) {
          const message = `DatadogRum sessionId: ${datadogRumSessionId}`;

          loggedToBrowser = logToBrowser(message, loggedToBrowser);
          loggedToJWeb = logToJWeb(message, jWeb, loggedToJWeb);

          if (
            shouldClearInterval(
              loggedToBrowser,
              loggedToJWeb,
              startTime,
              timeout
            )
          ) {
            clearInterval(intervalCheckToLogDatadogId);
          }
        }
      } catch (error) {
        console.error('DatadogRum initialization error: ', error);
      }
    }, 500);
  }

  private getDatadogRum(): RumPublicApi {
    return (window as any).DD_RUM;
  }
}

const datadogRum = new DatadogRum();

export default datadogRum;
